import { Navigate, useParams } from 'react-router-dom'

import { useCustomViewGroupPath } from 'modules/shift_management/lib/useCustomViewGroupPath'

const NavigateToViewIndexPage = () => {
  const params = useParams()
  const customPath = useCustomViewGroupPath(params)

  return <Navigate replace to={customPath} />
}

export default NavigateToViewIndexPage
